// Experience + skills, sourced from Bereket Zelalem's CV.

export const Experience = [
    {
        period: "May 2026 — Present",
        role: "Senior Backend Developer",
        company: "InfraTech Software Solutions",
        summary:
            "Designing and building scalable backend services, APIs and cloud-native solutions for enterprise products.",
        stack: ["Node.js", "Spring Boot", "Kubernetes", "PostgreSQL"],
    },
    {
        period: "Feb 2026 — May 2026",
        role: "Manager — Digital Channels Development & Operations",
        company: "Safaricom Telecommunications Ethiopia",
        summary:
            "Led development and operations of the Digital Lifestyle Super App — mini-app framework, a centralized game engine and local + international payment integrations (M-PESA, Stripe, Play & App Store).",
        stack: ["Next.js", "Flutter", "Nakama", "Stripe", "AWS"],
    },
    {
        period: "Apr 2023 — Jan 2026",
        role: "System Engineer — VAS Developer",
        company: "Safaricom Telecommunications Ethiopia",
        summary:
            "Designed, built and operated the IBEX USSD & Messaging Platform and SMS Trivia services — USSD, M-PESA and enterprise integrations serving millions of subscribers daily. Recognized by Safaricom Group leadership.",
        stack: ["Spring Boot", "Node.js", "MongoDB", "Dragonfly", "SMPP"],
    },
    {
        period: "Jun 2022 — Mar 2023",
        role: "Full Stack Web Developer",
        company: "DevCorner ET — Freelance",
        summary:
            "Delivered full-stack web platforms for clients and led the Angular 7 → 9 migration of the AZZLY Rize healthcare & telemedicine platform.",
        stack: ["Angular", "Laravel", "Node.js", "MySQL"],
    },
    {
        period: "Apr 2022 — Jun 2022",
        role: "Quality Assurance & Release Engineer",
        company: "Tikus Delivery",
        summary:
            "Owned release quality, testing and deployment processes for the delivery platform.",
        stack: ["QA", "CI/CD", "Release"],
    },
]

export const SkillGroups = [
    {
        title: "Languages",
        items: ["Java", "JavaScript", "TypeScript", "PHP", "C#", "SQL", "Bash"],
    },
    {
        title: "Frameworks",
        items: [
            "Spring Boot",
            "Node.js",
            "NestJS",
            "React",
            "Next.js",
            "Angular",
            "Vue.js",
            "Laravel",
        ],
    },
    {
        title: "Databases",
        items: [
            "PostgreSQL",
            "MySQL",
            "MongoDB",
            "Redis",
            "DragonflyDB",
            "Oracle",
            "MariaDB",
        ],
    },
    {
        title: "Cloud & DevOps",
        items: [
            "Docker",
            "Kubernetes",
            "AWS",
            "Azure",
            "GitLab CI/CD",
            "ArgoCD",
            "Helm",
            "Ansible",
        ],
    },
    {
        title: "Telecom / VAS",
        items: ["USSD", "SMS / SMPP", "Diameter", "M-PESA", "Charging GW", "CRM / BSS", "SDP"],
    },
    {
        title: "Observability",
        items: ["Grafana", "Prometheus", "VictoriaLogs", "ELK Stack"],
    },
]

export const Stats = [
    { value: "~5", label: "Years building software" },
    { value: "6+", label: "Enterprise platforms shipped" },
    { value: "Millions", label: "Customers served daily" },
]
